import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import set from 'lodash/set';
import flattenDeep from 'lodash/flattenDeep';
import pipe from '@/utils/pipe';
import deepClone from '@/utils/deepClone';
import { ordinalSectionsToArray, arraySectionsToOrdinal } from '@/utils/widget/ordinals';
import { arrayMove } from '@dnd-kit/sortable';
import parseSelections from '@/utils/widget/parseSelections';
import { deleteNullValues } from '@/utils/objects';
import getNormalizedValueType from '@/utils/reporting/getNormalizedValueType';
import { ordinalize } from '@/utils/strings';
import { compatibleLayouts } from '@/config/questions';
import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
import logger from '@/utils/logger';
import { lookupTarget, lookupTargetParent, lookupTargetSection, isTargetQuestionUpdate, lookupFirstFormatFromSelections, selectionToAddressMatrix } from './utils';
import addGenericSectionFor from './addGenericSectionFor';
import { isValidLayoutForValueType } from './createQuestions';
import updateQuestionLayout from './updateQuestionLayout';
import cleanupDeletedQuestion from './cleanupDeletedQuestion';
import { decodeQuestionHideWhen, encodeQuestionHideWhen } from '../questionHideWhen'; // TODO: Deprecate?  Relocate?
// import createQuestions from './createQuestions';

const PREFIX = 'common: utils: widget: update:';
const VALUE_TYPE_COMPATIBLE_LAYOUTS = compatibleLayouts;
const {
  getSpreadsheetIndex,
  cellReferencesToAddress
} = spreadsheetCore;
export default function update(_ref) {
  let {
    target,
    update,
    localState,
    workbook,
    formats
  } = _ref;
  const meta = []; // meta data regarding updates made

  const clone = deepClone(localState);
  const result = pipe(createMissingObject, applyUpdatesToExisting, addNewArrayItem, removeArrayItem, resortArrayItems, // Must be before layout
  updateQuestionValueType, // Must be before min/max/Checked
  transitionUpdatedQuestionLayout, updateQuestionMinMaxValues, syncQuestionHideWhen, setCheckedQuestionValues, removeSection, addSection, resortSections, // generateQuestions,
  syncCollectionOptions, syncSeriesOptions, // After sync series options
  addGlobalSeriesOptionTemplate, addGlobalSeriesOptionLabelsTemplate, // After sync line chart options
  addLineChartValueAxisTemplate, addLineChartLabelAxisTemplate, // After sync point chart options
  addPointChartTemplates, // After sync bar chart options
  addVerticalBarChartValueAxisTemplate, addHorizontalBarChartValueAxisTemplate, addVerticalBarChartLabelAxisTemplate, addHorizontalBarChartLabelAxisTemplate)(clone, {
    target,
    update,
    localState,
    workbook,
    formats
  }, meta);
  return {
    result,
    meta
  };
} // Create a missing nested object
// with a target, do not apply update

const createMissingObject = (result, config) => {
  const {
    target,
    update
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update === null || !isUpdateObject) {
    return result;
  } // NOTE: targets postfixed with keyword "new"
  // are managed by their individual function


  const isManagedNew = target.search(/\.new$/) > -1;
  const targetParent = lookupTargetParent(target, result);
  const recoveredTarget = lookupTarget(target, result);

  if (!isManagedNew && targetParent && recoveredTarget === undefined && typeof targetParent === 'object' && !Array.isArray(targetParent)) {
    const targetIdx = target.split('.').pop() || '';
    targetParent[targetIdx] = {};
  }

  return result;
}; // Update an existing resource within
// a widget that is recoverable


const applyUpdatesToExisting = (result, config) => {
  const {
    target,
    update
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update === null || !isUpdateObject) {
    return result;
  }

  const recoveredTarget = lookupTarget(target, result);

  if (recoveredTarget && typeof recoveredTarget === 'object') {
    Object.assign(recoveredTarget, update);
    deleteNullValues(recoveredTarget);
  }

  return result;
}; // Add any new item to any array
// within a widget


const addNewArrayItem = (result, config, meta) => {
  const {
    target,
    update
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update === null || !isUpdateObject) {
    return result;
  }

  const recoveredTarget = lookupTarget(target, result);
  const targetParent = lookupTargetParent(target, result);
  const isAdding = typeof recoveredTarget === 'undefined' && Array.isArray(targetParent);

  if (isAdding) {
    targetParent.push(update);
  }

  if (isAdding && isTargetQuestionUpdate(target) && update.id) {
    const sectionId = lookupTargetSection(target);
    meta.push({
      type: 'questions.added',
      parent: sectionId,
      value: update.id
    });
  }

  return result;
}; // Remove any item from any array
// within a  widget


const removeArrayItem = (result, config) => {
  const {
    target,
    update
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update !== null || !isUpdateObject) {
    return result;
  }

  const recoveredTarget = lookupTarget(target, result);
  const targetParent = lookupTargetParent(target, result);
  const targetIndex = parseInt(target.split('.').pop() || '', 10);

  if (!recoveredTarget || !Array.isArray(targetParent) || isNaN(targetIndex)) {
    return result;
  } // Delete item


  targetParent.splice(targetIndex, 1); // Cleanup any deleted question references

  if (isTargetQuestionUpdate(target)) {
    cleanupDeletedQuestion(result, targetParent, recoveredTarget);
  }

  return result;
}; // Reorganize an array of items based on a
// selected item and the desired index


const resortArrayItems = (result, config) => {
  const {
    target,
    update
  } = config;
  const isUpdateNumber = typeof update === 'number';

  if (!isUpdateNumber) {
    return result;
  }

  const recoveredTarget = lookupTarget(target, result);
  const previousIndex = parseInt(target.split('.').pop() || '', 10);
  const targetParent = lookupTargetParent(target, result);
  const isValidTargetIndex = typeof targetParent[update] !== 'undefined';

  if (typeof recoveredTarget !== 'undefined' && Array.isArray(targetParent) && !isNaN(previousIndex) && isValidTargetIndex) {
    const resortedArray = arrayMove(targetParent, previousIndex, update);
    targetParent.splice(0, resortedArray.length, ...resortedArray);
  }

  return result;
}; // Remove a section from a widget
// and re-sort the ordinal names of
// remaining sections


const removeSection = (result, config) => {
  const {
    target,
    update,
    localState
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update !== null || !isUpdateObject) {
    return result;
  }

  const recoveredTarget = lookupTarget(target, localState);
  const sectionId = lookupTargetSection(target);
  const targetSection = (localState.sections || {})[sectionId];
  const isSectionRemovalReq = targetSection && targetSection === recoveredTarget;

  if (isSectionRemovalReq) {
    const updatedSectionsList = ordinalSectionsToArray(result.sections || {}).filter(_ref2 => {
      let {
        id
      } = _ref2;
      return id !== sectionId;
    });
    result.sections = arraySectionsToOrdinal(updatedSectionsList);
  }

  return result;
}; // Add a section to a widget
// last position in the sections


const addSection = (result, config, meta) => {
  const {
    target,
    update
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update === null || !isUpdateObject) {
    return result;
  }

  const hasComponentType = update.component && typeof update.component === 'string';
  const isSectionAddReq = target === 'sections.new' && hasComponentType;
  const layoutGroup = update.layoutGroup || 'defaults';

  if (isSectionAddReq) {
    const updatedSectionsList = ordinalSectionsToArray(result.sections || {});
    const lastSectionInLayoutGroup = [...updatedSectionsList].reverse() // lookup from last first
    .find(section => {
      var _section$config;

      const sectionLayoutGroup = (section === null || section === void 0 ? void 0 : (_section$config = section.config) === null || _section$config === void 0 ? void 0 : _section$config.layoutGroup) || 'defaults';
      return sectionLayoutGroup === layoutGroup;
    }); // Find last index in layout group,
    // if one provided otherwise lookup
    // last index of all sections

    const targetIndex = !lastSectionInLayoutGroup ? updatedSectionsList.length : updatedSectionsList.indexOf(lastSectionInLayoutGroup) + 1;
    updatedSectionsList.splice(targetIndex, 0, addGenericSectionFor(update.component, layoutGroup));
    result.sections = arraySectionsToOrdinal(updatedSectionsList);
    meta.push({
      type: 'sections.added',
      value: ordinalize(targetIndex)
    });
  }

  return result;
}; // Resort a section to a new index within
// the sections ordinal hash


const resortSections = (result, config) => {
  const {
    target,
    update
  } = config;
  const isUpdateNumber = typeof update === 'number';
  const isTopLvlSectionTarget = target.search(/sections\.[a-z|-]+$/) > -1;

  if (!isUpdateNumber || !isTopLvlSectionTarget) {
    return result;
  }

  const targetId = target.split('.').pop();
  const targetParent = ordinalSectionsToArray(result.sections || {});
  const recoveredTarget = targetParent.find(_ref3 => {
    let {
      id
    } = _ref3;
    return id === targetId;
  });
  const previousIndex = recoveredTarget ? targetParent.indexOf(recoveredTarget) : -1;
  const isValidTargetIndex = typeof targetParent[update] !== 'undefined';

  if (Boolean(recoveredTarget) && Array.isArray(targetParent) && !isNaN(previousIndex) && previousIndex > -1 && isValidTargetIndex) {
    const resortedArray = arrayMove(targetParent, previousIndex, update);
    result.sections = arraySectionsToOrdinal(resortedArray);
  }

  return result;
}; // Ensure that questions always have a correct
// value type for their current spreadsheet selection


const updateQuestionValueType = (result, config) => {
  const {
    target,
    update,
    workbook
  } = config;
  const isUpdateObject = typeof update === 'object';
  const isQuestionUpdate = isTargetQuestionUpdate(target);
  const isDeleteUpdate = update === null;
  const isSelectionUpdate = !isDeleteUpdate && Boolean(Object.keys(update).find(key => key === 'selections')) && // @ts-ignore
  Boolean(update.selections);

  if (isDeleteUpdate || !isUpdateObject || !isQuestionUpdate || !isSelectionUpdate) {
    return result;
  }

  try {
    const recoveredTarget = lookupTarget(target, result);
    const currentValueType = getNormalizedValueType(recoveredTarget.valueType);
    const valueAddress = cellReferencesToAddress(update.selections).pop() || {
      row: -1,
      col: -1,
      sheet: -1
    };
    const sheet = workbook[valueAddress.sheet] || [];
    const spreadsheetValue = (sheet[valueAddress.row] || [])[valueAddress.col];
    const updatedValueType = getNormalizedValueType(typeof spreadsheetValue);

    if (updatedValueType !== currentValueType) {
      recoveredTarget.valueType = updatedValueType;
    }
  } catch (err) {
    logger.error(Error(`${PREFIX} updateQuestionValueType: unexpected selection failure: ${err}`));
  }

  return result;
}; // Set adjust min/max values for numeric questions
// to be valid for new numeric selections


const updateQuestionMinMaxValues = (result, config) => {
  const {
    target,
    update,
    workbook
  } = config;
  const isUpdateObject = typeof update === 'object';
  const isQuestionUpdate = isTargetQuestionUpdate(target);
  const isDeleteUpdate = update === null;
  const isSelectionUpdate = !isDeleteUpdate && Boolean(Object.keys(update).find(key => key === 'selections')) && // @ts-ignore
  Boolean(update.selections);

  if (isDeleteUpdate || !isUpdateObject || !isQuestionUpdate || !isSelectionUpdate) {
    return result;
  }

  try {
    const recoveredTarget = lookupTarget(target, result);
    const recoverdValueType = getNormalizedValueType(recoveredTarget.valueType);
    const isNumbericQuestion = 'integer' === recoverdValueType;
    const valueAddress = cellReferencesToAddress(update.selections).pop() || {
      row: -1,
      col: -1,
      sheet: -1
    };
    const sheet = workbook[valueAddress.sheet] || [];
    let spreadsheetValue = (sheet[valueAddress.row] || [])[valueAddress.col];

    if (typeof spreadsheetValue !== 'number') {
      spreadsheetValue = NaN;
    } // Correct maximum


    if (!isNaN(spreadsheetValue) && isNumbericQuestion && typeof recoveredTarget.maximumValue === 'number' && recoveredTarget.maximumValue < spreadsheetValue) {
      recoveredTarget.maximumValue = spreadsheetValue + 1;
    } // Correct minimum


    if (!isNaN(spreadsheetValue) && isNumbericQuestion && typeof recoveredTarget.minimumValue === 'number' && recoveredTarget.minimumValue > spreadsheetValue) {
      recoveredTarget.minimumValue = spreadsheetValue - 1;
    }
  } catch (err) {
    logger.error(Error(`${PREFIX} updateQuestionMinMaxValues: unexpected selection failure: ${err}`));
  }

  return result;
}; // Purge a deleted question from its'
// hideWhen rule subscribers


const syncQuestionHideWhen = (result, config) => {
  const {
    target,
    update,
    localState
  } = config;
  const isUpdateObject = typeof update === 'object';
  const isQuestionUpdate = isTargetQuestionUpdate(target);
  const isDeleteUpdate = update === null;

  if (!isUpdateObject || !isDeleteUpdate || !isQuestionUpdate) {
    return result;
  }

  try {
    const recoveredTarget = lookupTarget(target, localState);
    const formQuestions = lookupTargetParent(target, result);
    const deletedQuestionId = recoveredTarget.id;
    formQuestions.filter(_ref4 => {
      let {
        hideWhen
      } = _ref4;
      return Boolean(hideWhen);
    }).filter(_ref5 => {
      let {
        hideWhen
      } = _ref5;
      return hideWhen.search(`#${deletedQuestionId}`) > -1;
    }).forEach(question => {
      const hideWhenRules = decodeQuestionHideWhen(question.hideWhen);
      delete hideWhenRules.questions[deletedQuestionId] || {};
      question.hideWhen = encodeQuestionHideWhen(question.hideWhen); // Remove empty hide when rules

      if (!question.hideWhen) delete question.hideWhen;
    });
  } catch (err) {
    logger.error(Error(`${PREFIX} syncQuestionHideWhen: unexpected failure: ${err}`));
  }

  return result;
}; // Update a questions layout when it's
// value type is no longer compatible with it


const transitionUpdatedQuestionLayout = (result, config) => {
  const {
    target,
    update
  } = config;
  const isUpdateObject = typeof update === 'object';
  const isQuestionUpdate = isTargetQuestionUpdate(target);
  const isDeleteUpdate = update === null;
  const isSelectionsUpdate = isQuestionUpdate && !isDeleteUpdate && Object.keys(update).includes('selections');

  if (isDeleteUpdate || !isUpdateObject || !isQuestionUpdate) {
    return result;
  }

  let isLayoutUpdate = Boolean(Object.keys(update).find(key => key === 'layout')) && Boolean(update.layout);
  const recoveredTarget = lookupTarget(target, result);
  const valueType = getNormalizedValueType(recoveredTarget.valueType); // If question has any selection to base
  // its' value type on validate the layout

  const hasValidLayout = recoveredTarget.selections || isSelectionsUpdate ? isValidLayoutForValueType(valueType, recoveredTarget.layout) : true; // Automatically update to first
  // valid layout for target value type

  if (!hasValidLayout) {
    recoveredTarget.layout = VALUE_TYPE_COMPATIBLE_LAYOUTS[valueType][0];
    isLayoutUpdate = true;
  } // Transition question to have
  // valid default attributes for
  // the target layout


  if (isLayoutUpdate) {
    const missingAttrs = updateQuestionLayout(recoveredTarget);
    Object.assign(recoveredTarget, missingAttrs); // Apply layout updates

    deleteNullValues(recoveredTarget); // Remove deletes
  }

  return result;
}; // Ensure that checkbox questions
// only have valid checked/unchecked values
// for their current value type


const setCheckedQuestionValues = (result, config) => {
  const {
    target,
    update,
    workbook
  } = config;
  const isUpdateObject = typeof update === 'object';
  const isQuestionUpdate = isTargetQuestionUpdate(target);

  if (update === null || !isUpdateObject || !isQuestionUpdate) {
    return result;
  }

  const recoveredTarget = lookupTarget(target, result);
  const isCheckedQuestion = ['checkbox'].includes(recoveredTarget.layout);
  const typeofCheckedValue = typeof recoveredTarget.checkedValue;
  const valueType = getNormalizedValueType(recoveredTarget.valueType);
  const requiredType = valueType === 'integer' ? 'number' : valueType; // Question's checked values do not need updating

  if (!isCheckedQuestion || typeofCheckedValue === requiredType) {
    return result;
  }

  const valueAddress = cellReferencesToAddress(update.selections || '').pop() || {
    row: -1,
    col: -1,
    sheet: -1
  };
  const sheet = workbook[valueAddress.sheet] || [];
  const spreadsheetValue = (sheet[valueAddress.row] || [])[valueAddress.col];
  if (spreadsheetValue === undefined) return result; // sanity check
  // Update the checked/unchecked default values

  if (requiredType === 'string') {
    recoveredTarget.checkedValue = spreadsheetValue;
    recoveredTarget.uncheckedValue = '';
  } else if (requiredType === 'number') {
    recoveredTarget.checkedValue = spreadsheetValue;
    recoveredTarget.uncheckedValue = 0;
  } else if (requiredType === 'boolean') {
    recoveredTarget.checkedValue = true;
    recoveredTarget.uncheckedValue = false;
  }

  return result;
}; // Merge existing, delete, or add new questions
// configurations to form section
//
// TODO: Deprecate?
//
// function generateQuestions(result, config): Widget {
//   const { target, update, spreadsheetResults } = config;
//   const isUpdateObject = typeof update === 'object';
//   if (
//     update === null ||
//     !isUpdateObject ||
//     // Is section config update
//     target.search(/sections\..+\.config$/) < 0
//   ) {
//     return result;
//   }
//   const sectionTarget = target.split('.').slice(0, -1).join('.');
//   const sectionId = sectionTarget.split('.').pop();
//   const recoveredSection = lookupTarget(sectionTarget, result) || {};
//   const isSelectionsUpdate = Boolean(
//     Object.keys(update).find((key) => key === 'selections')
//   );
//   if (isFormSection(recoveredSection) && isSelectionsUpdate) {
//     const section = deepClone(recoveredSection);
//     section.config.selections = parseSelections(update.selections);
//     const results = [{ data: [spreadsheetResults, []] }] as ResultsModel[];
//     const [updatedSelections] = createSelections(results, section);
//     const selectionGroups = {
//       selections: update.selections,
//       data: updatedSelections.reduce((acc, { data }) => {
//         acc.push(...data);
//         return acc;
//       }, []),
//     };
//     // Persist selections reference
//     result.sections[sectionId].config.selections = update.selections;
//     // Persist merged/new/deleted questions
//     result.sections[sectionId].config.questions = createQuestions(
//       selectionGroups,
//       section.config.questions
//     );
//   }
//   return result;
// }
// Sync selections with collection options:
// - NOTE: These map to top-level only selection groups
// - Add: new options when new selection group created
// - Remove: when collection no longer exists


const syncCollectionOptions = (result, config) => {
  const {
    target,
    update
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update === null || !isUpdateObject || // Is section config update
  target.search(/sections\..+\.config$/) < 0 || !Object.keys(update || {}).some(key => key === 'selections')) {
    return result;
  }

  const updatedCollections = parseSelections(update.selections);
  const sectionTarget = target.split('.').slice(0, -1).join('.');
  const recoveredSection = lookupTarget(sectionTarget, result) || {};
  const collectionOptions = recoveredSection.config.collectionOptions || []; // Lookup any matching collection option, by index,
  // and use existing options or append blank

  recoveredSection.config.collectionOptions = updatedCollections.map((_, collectionIndex) => {
    const option = collectionOptions[collectionIndex] || {};
    return _objectSpread({}, option);
  });
  return result;
}; // Sync selections with series options:
// - Remove series options that no longer apply
// - Add default option for newly added selections


const syncSeriesOptions = (result, config) => {
  const {
    target,
    update
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update === null || !isUpdateObject || // Is section config update
  target.search(/sections\..+\.config$/) < 0 || !Object.keys(update || {}).some(key => key === 'selections')) {
    return result;
  }

  const updatedSelections = flattenDeep(parseSelections(update.selections));
  const sectionTarget = target.split('.').slice(0, -1).join('.');
  const recoveredSection = lookupTarget(sectionTarget, result) || {};
  const seriesOptions = recoveredSection.config.seriesOptions || []; // Lookup any matching series option, by index,
  // and use existing options or create blank

  recoveredSection.config.seriesOptions = updatedSelections.map((selection, selectionIndex) => {
    const option = seriesOptions[selectionIndex] || {};
    return _objectSpread(_objectSpread({}, option), {}, {
      selections: selection
    }); // Ensure selection always has an option
  });
  return result;
}; // Add default selection template to
// each of the newly added selections


const applyTemplateBasedOnSelection = (result, config, options) => {
  const {
    target,
    update,
    formats
  } = config;
  const {
    selectionKey,
    targetPath,
    componentFilter
  } = options;
  const isUpdateObject = typeof update === 'object';

  if (update === null || !isUpdateObject || // Is section config update
  target.search(/sections\..+\.config$/) < 0 || !Object.keys(update || {}).some(key => key === selectionKey)) {
    return result;
  } // Find the target section


  const sectionTarget = target.split('.').slice(0, -1).join('.');
  const recoveredSection = lookupTarget(sectionTarget, result) || {}; // Check if the component type matches the filter

  if (!componentFilter(recoveredSection.component, recoveredSection)) {
    return result; // Component type should be ignored for this template
  } // Get the format from selections


  const updatedSelections = flattenDeep(parseSelections(update[selectionKey]));
  const firstSelectedFormat = lookupFirstFormatFromSelections(updatedSelections, formats); // Apply the template if a format was found

  if (firstSelectedFormat) {
    const template = `{{value | ssf ${firstSelectedFormat}}}`;
    set(recoveredSection.config, targetPath, template);
  }

  return result;
};

const barChartComponents = ['BarChart', 'StackedBarChart'];
const componentsWithCustomTemplates = ['LineChart', 'Bubble', 'Scatter', ...barChartComponents]; // Add template to globalSeriesOptions.template using 'selections'

export const addGlobalSeriesOptionTemplate = (result, config) => {
  return applyTemplateBasedOnSelection(result, config, {
    selectionKey: 'selections',
    targetPath: 'globalSeriesOptions.template',
    componentFilter: component => !componentsWithCustomTemplates.includes(component)
  });
}; // Add template to yAxisTemplate for LineCharts using 'selections'

export const addLineChartValueAxisTemplate = (result, config) => {
  return applyTemplateBasedOnSelection(result, config, {
    selectionKey: 'selections',
    targetPath: 'globalSeriesOptions.yAxisTemplate',
    componentFilter: component => component === 'LineChart' // Apply ONLY for LineChart

  });
}; // Add template to yAxisTemplate for BarCharts using 'selections'

export const addVerticalBarChartValueAxisTemplate = (result, config) => {
  return applyTemplateBasedOnSelection(result, config, {
    selectionKey: 'selections',
    targetPath: 'globalSeriesOptions.yAxisTemplate',
    componentFilter: (component, section) => barChartComponents.includes(component) && section.config.chartType !== 'horizontal' // Apply ONLY for Vertical BarChart

  });
}; // Add template to xAxisTemplate for BarCharts using 'selections'

export const addHorizontalBarChartValueAxisTemplate = (result, config) => {
  return applyTemplateBasedOnSelection(result, config, {
    selectionKey: 'selections',
    targetPath: 'globalSeriesOptions.xAxisTemplate',
    componentFilter: (component, section) => barChartComponents.includes(component) && section.config.chartType === 'horizontal' // Apply ONLY for Horizontal BarChart

  });
}; // Add template to globalSeriesOptions.labelsTemplate using 'labelsSelections'

export const addGlobalSeriesOptionLabelsTemplate = (result, config) => {
  return applyTemplateBasedOnSelection(result, config, {
    selectionKey: 'labelsSelections',
    targetPath: 'globalSeriesOptions.labelsTemplate',
    componentFilter: component => !componentsWithCustomTemplates.includes(component)
  });
}; // Add template to xAxisTemplate using 'labelsSelections'

export const addLineChartLabelAxisTemplate = (result, config) => {
  return applyTemplateBasedOnSelection(result, config, {
    selectionKey: 'labelsSelections',
    targetPath: 'globalSeriesOptions.xAxisTemplate',
    componentFilter: component => component === 'LineChart' // Apply ONLY for LineChart

  });
}; // Add template to yAxisTemplate using 'labelsSelections'

export const addHorizontalBarChartLabelAxisTemplate = (result, config) => {
  return applyTemplateBasedOnSelection(result, config, {
    selectionKey: 'labelsSelections',
    targetPath: 'globalSeriesOptions.yAxisTemplate',
    componentFilter: (component, section) => barChartComponents.includes(component) && section.config.chartType === 'horizontal' // Apply ONLY for Horizontal BarChart

  });
}; // Add template to xAxisTemplate using 'labelsSelections'

export const addVerticalBarChartLabelAxisTemplate = (result, config) => {
  return applyTemplateBasedOnSelection(result, config, {
    selectionKey: 'labelsSelections',
    targetPath: 'globalSeriesOptions.xAxisTemplate',
    componentFilter: (component, section) => barChartComponents.includes(component) && section.config.chartType !== 'horizontal' // Apply ONLY for Vertical BarChart

  });
}; // Apply point chart templates to globalSeriesOptions using 'selections'

export const addPointChartTemplates = (result, config) => {
  const {
    target,
    update,
    formats
  } = config;
  const isUpdateObject = typeof update === 'object';

  if (update === null || !isUpdateObject || // Is section config update
  target.search(/sections\..+\.config$/) < 0 || !Object.keys(update || {}).some(key => key === 'selections')) {
    return result;
  } // Find the target section


  const sectionTarget = target.split('.').slice(0, -1).join('.');
  const recoveredSection = lookupTarget(sectionTarget, result) || {}; // Check if the component type matches the filter

  if (!['Bubble', 'Scatter'].includes(recoveredSection.component)) {
    return result; // Component type should be ignored for this template
  } // Get the formats from selection


  const selection = flattenDeep(parseSelections(update.selections))[0];
  const sheetIndex = getSpreadsheetIndex(selection);
  const firstRow = selectionToAddressMatrix(selection, 1)[0];
  const [xAxisTemplate, yAxisTemplate, pointTemplate] = firstRow.map(cell => (formats[sheetIndex] || {})[cell.ref || '']); // Apply the x axis template if a format was found

  if (xAxisTemplate) {
    const template = `{{value | ssf ${xAxisTemplate}}}`;
    set(recoveredSection.config, 'globalSeriesOptions.xAxisTemplate', template);
  } // Apply the y axis template if a format was found


  if (yAxisTemplate) {
    const template = `{{value | ssf ${yAxisTemplate}}}`;
    set(recoveredSection.config, 'globalSeriesOptions.yAxisTemplate', template);
  } // Apply the radius template for bubble chart if a format was found


  if (recoveredSection.component === 'Bubble' && pointTemplate) {
    const template = `{{value | ssf ${pointTemplate}}}`;
    set(recoveredSection.config, 'globalSeriesOptions.pointTemplate', template);
  }

  return result;
};